module.exports = __webpack_public_path__ + "static/media/400168_02.c71ea8ba.png";